import "core-js/modules/es.array.filter";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          mutation ( $dataB64: String!, $jobId: String!) {\n            importSchools(\n              dataB64: $dataB64,\n              jobId: $jobId\n            )\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import gql from 'graphql-tag';
import { SchoolsOrderBy } from '@/interfaces/school';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppCheckbox from '@/components/AppCheckbox.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppTextarea from '@/components/AppTextarea.vue';
import SchoolDialog from './script-dialog';
import ListPage from '@/mixins/list-page';
import { exportSchoolsList, findSchools } from './gql';
import { importExcel } from '@/utils/excel';
import UploadingJob from '@/mixins/uploading-job';
import AppLoading from '@/components/AppLoading.vue';
import { downloadBase64 } from '@/helpers/base64-to-file';

var SchoolList = /*#__PURE__*/function (_mixins) {
  _inherits(SchoolList, _mixins);

  var _super = _createSuper(SchoolList);

  function SchoolList() {
    var _this;

    _classCallCheck(this, SchoolList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '学校管理'
    }, {
      text: '学校'
    }];
    _this.selectedScools = [];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.filter = {
      name: '',
      area: null
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.disableConfirm = false;
    _this.headers = [{
      text: '学校名称',
      value: 'name'
    }, {
      text: '地区',
      value: 'area.mergerName',
      sortable: false
    }, {
      text: '创建时间',
      value: 'createdAt'
    }, {
      text: '创建人',
      value: 'managers.createdBy.username',
      sortable: false
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.disabledActions = true;
    _this.schools = [];
    _this.selectedSchools = [];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.showLoading = false;
    _this.actionsHeight = 51;
    return _this;
  }

  _createClass(SchoolList, [{
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getSchools();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.getRole() === 'dealer') {
        this.headers.pop();
      }

      this.checkIfJobRunnig();
      this.onResize();
      this.restorePage(this.cache);
      this.getSchools();
    }
  }, {
    key: "refreshList",
    value: function () {
      var _refreshList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.filter = {
                  name: '',
                  area: null
                };
                this.getSchools();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshList() {
        return _refreshList.apply(this, arguments);
      }

      return refreshList;
    }()
  }, {
    key: "getSchools",
    value: function () {
      var _getSchools = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, area, name, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, area = _this$filter.area, name = _this$filter.name;
                by = SchoolsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  name: name || null,
                  areaId: (area === null || area === void 0 ? void 0 : area.id) || null
                };
                _context2.next = 10;
                return this.querySchoolsRequest(order, paging, where);

              case 10:
                result = _context2.sent;

                if (result) {
                  this.schools = result.schools;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSchools() {
        return _getSchools.apply(this, arguments);
      }

      return getSchools;
    }()
  }, {
    key: "querySchoolsRequest",
    value: function () {
      var _querySchoolsRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findSchools,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findSchools);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function querySchoolsRequest(_x, _x2, _x3) {
        return _querySchoolsRequest.apply(this, arguments);
      }

      return querySchoolsRequest;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function () {
      var _filterQuerySubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getSchools();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function filterQuerySubmit() {
        return _filterQuerySubmit.apply(this, arguments);
      }

      return filterQuerySubmit;
    }()
  }, {
    key: "deleteConfirm",
    value: function () {
      var _deleteConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.deleteSchoolById();

              case 2:
                _context5.next = 4;
                return this.getSchools();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteConfirm() {
        return _deleteConfirm.apply(this, arguments);
      }

      return deleteConfirm;
    }()
  }, {
    key: "importSchoolRequest",
    value: function () {
      var _importSchoolRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dataB64, jobId) {
        var result, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.$apollo.mutate({
                  mutation: gql(_templateObject()),
                  variables: {
                    dataB64: dataB64,
                    jobId: jobId
                  }
                });

              case 3:
                result = _context6.sent;
                res = result.data.importSchools;

                if (res) {
                  showNotification({
                    msg: '导入学校成功',
                    type: SnackType.Info
                  });
                  this.clearLoadingJob();
                  this.getSchools();
                }

                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                this.getRunningJob(jobId);
                showErrors(_context6.t0.graphQLErrors);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function importSchoolRequest(_x4, _x5) {
        return _importSchoolRequest.apply(this, arguments);
      }

      return importSchoolRequest;
    }()
  }, {
    key: "addFile",
    value: function addFile() {
      var _this2 = this;

      importExcel( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(data) {
          var dataB64, jobId;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  dataB64 = Buffer.from(JSON.stringify(data)).toString('base64');
                  _context7.next = 3;
                  return _this2.createUploadingJob();

                case 3:
                  jobId = _context7.sent;
                  _this2.showLoading = true;

                  _this2.importSchoolRequest(dataB64, jobId);

                case 6:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x6) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "downloadFile",
    value: function downloadFile() {
      window.open(process.env.VUE_APP_OSS_URL + '/excel_samples/school_imports_sample.xlsx');
    }
  }, {
    key: "routeToDetail",
    value: function routeToDetail(item) {
      this.$router.push({
        name: 'SchoolDetail',
        params: {
          id: item.id,
          name: item.name
        }
      });
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this$options2, sortBy, sortDesc, _this$filter2, name, area, by, asc, order, where, result, _result$data$exportSc, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, name = _this$filter2.name, area = _this$filter2.area;
                by = SchoolsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  name: name || null,
                  areaId: (area === null || area === void 0 ? void 0 : area.id) || null
                };
                _context8.prev = 8;
                _context8.next = 11;
                return this.$apollo.query({
                  query: exportSchoolsList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context8.sent;

                if (result.data) {
                  _result$data$exportSc = result.data.exportSchoolsList, fileName = _result$data$exportSc.fileName, contentB64 = _result$data$exportSc.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](8);
                typedError = _context8.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }]);

  return SchoolList;
}(mixins(SchoolDialog, ListPage, UploadingJob));

__decorate([State(function (state) {
  return state.page.SchoolList;
})], SchoolList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], SchoolList.prototype, "onOptionsChanged", null);

SchoolList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppCheckbox: AppCheckbox,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppSearchBtn: AppSearchBtn,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppTextarea: AppTextarea,
    AppLoading: AppLoading
  }
})], SchoolList);
export default SchoolList;